var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		821,
		88
	],
	"./ion-action-sheet-ios.entry.js": [
		822,
		89
	],
	"./ion-action-sheet-md.entry.js": [
		823,
		90
	],
	"./ion-alert-ios.entry.js": [
		824,
		69
	],
	"./ion-alert-md.entry.js": [
		825,
		70
	],
	"./ion-app_8-ios.entry.js": [
		826,
		49
	],
	"./ion-app_8-md.entry.js": [
		827,
		50
	],
	"./ion-avatar_3-ios.entry.js": [
		828,
		91
	],
	"./ion-avatar_3-md.entry.js": [
		829,
		92
	],
	"./ion-back-button-ios.entry.js": [
		830,
		93
	],
	"./ion-back-button-md.entry.js": [
		831,
		94
	],
	"./ion-backdrop-ios.entry.js": [
		832,
		126
	],
	"./ion-backdrop-md.entry.js": [
		833,
		127
	],
	"./ion-button_2-ios.entry.js": [
		834,
		95
	],
	"./ion-button_2-md.entry.js": [
		835,
		96
	],
	"./ion-card_5-ios.entry.js": [
		836,
		97
	],
	"./ion-card_5-md.entry.js": [
		837,
		98
	],
	"./ion-checkbox-ios.entry.js": [
		838,
		99
	],
	"./ion-checkbox-md.entry.js": [
		839,
		100
	],
	"./ion-chip-ios.entry.js": [
		840,
		101
	],
	"./ion-chip-md.entry.js": [
		841,
		102
	],
	"./ion-col_3.entry.js": [
		842,
		128
	],
	"./ion-datetime_3-ios.entry.js": [
		843,
		65
	],
	"./ion-datetime_3-md.entry.js": [
		844,
		66
	],
	"./ion-fab_3-ios.entry.js": [
		845,
		103
	],
	"./ion-fab_3-md.entry.js": [
		846,
		104
	],
	"./ion-img.entry.js": [
		847,
		129
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		848,
		84
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		849,
		85
	],
	"./ion-input-ios.entry.js": [
		850,
		105
	],
	"./ion-input-md.entry.js": [
		851,
		106
	],
	"./ion-item-option_3-ios.entry.js": [
		852,
		107
	],
	"./ion-item-option_3-md.entry.js": [
		853,
		108
	],
	"./ion-item_8-ios.entry.js": [
		854,
		109
	],
	"./ion-item_8-md.entry.js": [
		855,
		110
	],
	"./ion-loading-ios.entry.js": [
		856,
		71
	],
	"./ion-loading-md.entry.js": [
		857,
		72
	],
	"./ion-menu_4-ios.entry.js": [
		858,
		63
	],
	"./ion-menu_4-md.entry.js": [
		859,
		64
	],
	"./ion-modal-ios.entry.js": [
		860,
		55
	],
	"./ion-modal-md.entry.js": [
		861,
		56
	],
	"./ion-nav_5.entry.js": [
		862,
		54
	],
	"./ion-popover-ios.entry.js": [
		863,
		57
	],
	"./ion-popover-md.entry.js": [
		864,
		58
	],
	"./ion-progress-bar-ios.entry.js": [
		865,
		111
	],
	"./ion-progress-bar-md.entry.js": [
		866,
		112
	],
	"./ion-radio_2-ios.entry.js": [
		867,
		77
	],
	"./ion-radio_2-md.entry.js": [
		868,
		78
	],
	"./ion-range-ios.entry.js": [
		869,
		113
	],
	"./ion-range-md.entry.js": [
		870,
		114
	],
	"./ion-refresher_2-ios.entry.js": [
		871,
		86
	],
	"./ion-refresher_2-md.entry.js": [
		872,
		87
	],
	"./ion-reorder_2-ios.entry.js": [
		873,
		82
	],
	"./ion-reorder_2-md.entry.js": [
		874,
		83
	],
	"./ion-ripple-effect.entry.js": [
		875,
		130
	],
	"./ion-route_4.entry.js": [
		876,
		115
	],
	"./ion-searchbar-ios.entry.js": [
		877,
		73
	],
	"./ion-searchbar-md.entry.js": [
		878,
		74
	],
	"./ion-segment_2-ios.entry.js": [
		879,
		116
	],
	"./ion-segment_2-md.entry.js": [
		880,
		117
	],
	"./ion-select_3-ios.entry.js": [
		881,
		79
	],
	"./ion-select_3-md.entry.js": [
		882,
		80
	],
	"./ion-slide_2-ios.entry.js": [
		883,
		131
	],
	"./ion-slide_2-md.entry.js": [
		884,
		132
	],
	"./ion-spinner.entry.js": [
		885,
		118
	],
	"./ion-split-pane-ios.entry.js": [
		886,
		133
	],
	"./ion-split-pane-md.entry.js": [
		887,
		134
	],
	"./ion-tab-bar_2-ios.entry.js": [
		888,
		119
	],
	"./ion-tab-bar_2-md.entry.js": [
		889,
		120
	],
	"./ion-tab_2.entry.js": [
		890,
		81
	],
	"./ion-text.entry.js": [
		891,
		121
	],
	"./ion-textarea-ios.entry.js": [
		892,
		122
	],
	"./ion-textarea-md.entry.js": [
		893,
		123
	],
	"./ion-toast-ios.entry.js": [
		894,
		75
	],
	"./ion-toast-md.entry.js": [
		895,
		76
	],
	"./ion-toggle-ios.entry.js": [
		896,
		67
	],
	"./ion-toggle-md.entry.js": [
		897,
		68
	],
	"./ion-virtual-scroll.entry.js": [
		898,
		135
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 397;
module.exports = webpackAsyncContext;